import React from "react";
import Modal from "react-bootstrap/Modal";

const DeleteFaqModal = ({ show, onHide, onConfirm }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Body style={{ padding: "24px", borderRadius: "24px", textAlign: 'center' }}>
                <div className="al-rp-img d-flex justify-content-center">
                    <img
                        style={{
                            width: "5rem",
                        }}
                        src={`${process.env.PUBLIC_URL}/img/delete-icon.png`}
                        alt="Alert Image"
                    />
                </div>
                <h3 style={{ marginBottom: '16px' }}>Delete FAQ</h3>
                <p style={{ color: '#6B7280', marginBottom: '24px' }}>
                    Are you sure you want to delete this FAQ? This action cannot be undone.
                </p>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={onHide} style={{ flex: 1, padding: '12px', border: '1px solid #9CA3AF', borderRadius: '27px', background: 'white', color: '#9CA3AF', cursor: 'pointer' }}>
                        Cancel
                    </button>
                    <button onClick={onConfirm} style={{ flex: 1, padding: '12px', background: '#DC2626', borderRadius: '27px', color: 'white', border: 'none', cursor: 'pointer' }}>
                        Delete
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteFaqModal;
